import { render } from "./profileIntro.vue?vue&type=template&id=1acf29f4"
import script from "./profileIntro.vue?vue&type=script&lang=js"
export * from "./profileIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__